/* Free Roam missions — reveal N random cards from the section's game blocks on every load.

   The cards are rendered server-side by snippets/mq-card.liquid (the same snippet the home
   marquee uses), so the card design and artwork can't drift between the two. This script
   only chooses which ones are visible and renumbers them 01..N.

   Why client-side: Liquid has no random filter and Shopify caches rendered sections, so a
   server-side pick would freeze on one set. With JS off, every card shows — still valid. */
(function () {
  document.querySelectorAll('[data-fr-missions]').forEach(function (host) {
  var cards = [].slice.call(host.querySelectorAll('.mq-card'));
  var count = parseInt(host.getAttribute('data-count'), 10) || 6;
  if (cards.length <= count) return; // fewer titles than slots — show them all, as rendered

  /* Fisher-Yates over a copy of the node list */
  var pool = cards.slice();
  for (var i = pool.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
  }
  var pick = pool.slice(0, count);

  cards.forEach(function (c) { if (pick.indexOf(c) === -1) c.remove(); });

  /* card numbers come from the Liquid loop index, so a random six would read 07, 23, 31 —
     renumber the survivors. Sort by DOM position first: `pick` is in shuffled order, and
     numbering that way makes the row read 01, 05, 02... left to right. */
  pick.sort(function (a, b) {
    return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  });
  pick.forEach(function (c, k) {
    var n = (k + 1 < 10 ? '0' : '') + (k + 1);
    var plate = c.querySelector('.mq-num');
    if (plate) plate.innerHTML = n + ' <i>//</i> ' + (plate.textContent.split('//')[1] || ' FREE ROAM').trim();
    var ghost = c.querySelector('.mq-ghost');
    if (ghost) ghost.textContent = n;
  });

  host.setAttribute('data-shuffled', '');
  });
})();
